module.exports = __webpack_public_path__ + "img/tab-calibration-selected.5710948a.png";